import CryptoJS from "crypto-js";
import { getConfig } from "../services/configService";

// Lazily read secret from runtime config to avoid calling getConfig() at module load
const getSecretKey = (): string => {
  try {
    return getConfig().REACT_APP_ENC_SECRET_KEY ?? "";
  } catch (e) {
    console.warn("Config not loaded: encryption secret is empty");
    return "";
  }
};

// Encrypt a value using the runtime secret (returns Base64 ciphertext)
export const encryptData = (data: string) => {
  const key = getSecretKey();
  if (!key) throw new Error("Encryption secret not available");
  return CryptoJS.AES.encrypt(data, key).toString();
};

// Decrypt a value using the runtime secret
export const decryptData = (cipherText: string) => {
  try {
    const key = getSecretKey();
    if (!key) return null;
    const bytes = CryptoJS.AES.decrypt(cipherText, key);
    return bytes.toString(CryptoJS.enc.Utf8) || null;
  } catch (error) {
    console.error("Decryption failed", error);
    return null;
  }
};
